import { ErrorDO } from './../../../BaseFramework/shared/models/error.model';
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
    ValidationUtilService,
    ApiRequestService,
    LookupDataService,
    CommonUtilty,
    I18nService,
    MultiLingualService,
    InteractService,
    ComponentOutputDO,
    AppMetadataHandler,
    CountryCityService
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { environment } from 'environments/environment';
import { OtherPolicyDO } from './../../../BaseFramework/shared/models/otherPolicy.model';


interface ValidationOutput {
    isInvalid: boolean,
    errorDOs: Array<ErrorDO>
}

@Component({
    selector: 'app-other-policy',
    templateUrl: './other-policy.component.html',
    styleUrls: ['./other-policy.component.scss']
})

export class OtherPolicyComponent implements OnInit {
    _currentComponentName = 'OtherPolicyComponent'
    constructor(private viewContainerRef: ViewContainerRef,
        public validationUtilService: ValidationUtilService,
        private apiRequestService: ApiRequestService,
        private route: ActivatedRoute,
        private router: Router,
        private fb: FormBuilder,
        private commonUtilty: CommonUtilty,
        private i18nService: I18nService,
        private multiLingualService: MultiLingualService,
        private translateService: TranslateService,
        private lookupDataService: LookupDataService,
        private interactService: InteractService,
        public appMetadataHandler: AppMetadataHandler,
        private countryCityService: CountryCityService) { }

    //Declaraions which might need developer input
    otherPolicyForm: FormGroup
    OTHERPOLICYFORMNAME = "otherPolicyForm"
    lookupsToBind = ['insuranceProvider', "policyStatusCd"]
    selectorOfThisComponent = 'app-other-policy'
    parentEvent$
    otherPolicyList = [];
    item

    public currencyOptions = {
        prefix: this.appMetadataHandler.baseCurrencyPREFIX,
        thousands: this.appMetadataHandler.THOUSANDS_SEPARATOR,
        decimal: this.appMetadataHandler.DECIMAL_SEPARATOR,
        align: this.appMetadataHandler.currencyAlignment
    }

    /**
     *
     *  Ninad: Whenever any developer is creating a new Component,
     * please make sure that you copy all import commands, constructor and
     * Boiler and Component Creation Kickstart CODE 
     *
     * 
     * Component Creation Kickstart CODE 
     */

    //ComponentSpecific Inputs, Outputs
    @Output() componentOutput = new EventEmitter<any>();
    @Input() type: string;
    private _inputDataForEdit = null;
    @Input()
    set inputDataForEdit(value: any) {
        console.log("inputDataForEdit for other policy", JSON.stringify(value))
        if (value) this._inputDataForEdit = value;
    };
    @Input() transactionState: string;
    @Input() DOName: any;
    @Input() otherPolicyNode: any;

    EmitComponentOutput(data) {
        let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
    }
    getParentComponent(): Component {
        try {
            return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
        } catch { }
    }
    getParentComponentName(): string {
        try {
            return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
        } catch { }
    }
    getCurrentComponentName(): string {
        return this._currentComponentName
    }

    subscribeToParentEvent() {
        if (this.parentEvent$ != null)
            this.parentEvent$.unsubscribe()
        this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
            const matches = param.filter(s => s.includes(this.getCurrentComponentName()));
            if (this.commonUtilty.isArrayIterable(param) && this.commonUtilty.isArrayIterable(matches)) {
                let isOutputValid = this.validateOutput(this.otherPolicyForm)
                if (isOutputValid)
                    this.EmitComponentOutput(this.otherPolicyForm)
                else {
                    this.EmitComponentOutput(isOutputValid)
                }
            }
            else {
                console.warn(`${this.getCurrentComponentName()} recieved the ping, but is not a emitter child for current transaction type.`)
            }
        })
    }

    validateOutput(o: FormGroup): ValidationOutput {
        this.commonUtilty.markAllFieldDirty(o);

        let validationOutput: ValidationOutput = {
            isInvalid: null,
            errorDOs: []
        }
        validationOutput.errorDOs = this.checkInvalidAndEmptyFields(o, this.getCurrentComponentName())

        if (Array.isArray(validationOutput.errorDOs) && validationOutput.errorDOs.length > 0) {
            validationOutput.isInvalid = true;
        }
        else {
            validationOutput.isInvalid = false;
        }

        return validationOutput
    }


    //Initializations
    lookup$: any = this.commonUtilty.initializeLookupList(this.lookupsToBind)

    ngOnInit() {
        const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
        if (environment && !environment.production) {
            console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
            console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
            console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
            console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
            console.groupEnd();
        }
        this.initializeOtherPolicyForm(this._inputDataForEdit)
        this.subscribeToParentEvent()
        this.initializeOtherPolicyListEditMode();
    }

    initializeOtherPolicyListEditMode() {
        if (this.commonUtilty.isArrayIterable(this._inputDataForEdit)) {
            this.otherPolicyList = this._inputDataForEdit;
        }
    }


    /**
     * Form Trasactions
     */

    // initializeOtherPolicyForm(data?, isEdit?, index?) {
    //     let payload = data || {}
    //     console.log("payload in other policy component", JSON.stringify(payload));
    //     this.otherPolicyForm = this.fb.group({
    //         provider: "",
    //         productName: "",
    //         policyNumber: this.validationUtilService.setValidationsForFormControl('policyNumber', this.OTHERPOLICYFORMNAME, payload['policyNum']),
    //         policyExpiryDt: this.validationUtilService.setValidationsForFormControl('policyExpiryDt', this.OTHERPOLICYFORMNAME, payload['expiryDt']),
    //         sumInsured: this.validationUtilService.setValidationsForFormControl('sumInsured', this.OTHERPOLICYFORMNAME, payload['sumInsured']),
    //         premium: this.validationUtilService.setValidationsForFormControl('premium', this.OTHERPOLICYFORMNAME, payload['premium']),
    //         term: this.validationUtilService.setValidationsForFormControl('term', this.OTHERPOLICYFORMNAME, payload['term']),
    //         policyStatus: this.validationUtilService.setValidationsForFormControl('policyStatus', this.OTHERPOLICYFORMNAME, payload['statusCd']),
    //     });
    // }

    isRequired(fieldName) {
        let returnObj = this.validationUtilService.isRequired(fieldName, this.OTHERPOLICYFORMNAME)
        return returnObj
    }

    public checkInvalidAndEmptyFields(Form: FormGroup, componentName) {
        let invalidFields = [];
        if (!Form.valid) {
            for (const i in Form.controls) {

                let controlName = this.commonUtilty.getControlName(Form.controls[i])
                let validationErrorList = this.validationUtilService.getUIErrorList(this.otherPolicyForm.get(controlName), this.OTHERPOLICYFORMNAME)
                if (Form.controls[i].status === 'INVALID') {
                    validationErrorList.forEach(validationError => {
                        let errorDO = new ErrorDO();
                        errorDO.errorMsg = validationError;
                        errorDO.fieldName = controlName;
                        // errorDO.fieldNameDescription = this.FormFieldNameMap[controlName]
                        errorDO.componentName = componentName;
                        invalidFields.push(errorDO)
                    })
                }
            }
        }
        return invalidFields;
    }

    addOtherPolicyDetails() {
        if (this.otherPolicyForm.status === 'VALID') {
            let otherPolicyDO = new OtherPolicyDO();

            otherPolicyDO.provider = this.otherPolicyForm.value.provider;
            otherPolicyDO.policyNum = this.otherPolicyForm.value.policyNumber;
            otherPolicyDO.expiryDt = this.otherPolicyForm.value.policyExpiryDt;
            otherPolicyDO.sumInsured = this.otherPolicyForm.value.sumInsured;
            otherPolicyDO.term = this.otherPolicyForm.value.term;
            otherPolicyDO.premium = this.otherPolicyForm.value.premium;
            otherPolicyDO.statusCd = this.otherPolicyForm.value.policyStatus;


            if (this.otherPolicyForm.value.isEdit) {
                this.otherPolicyList.splice(this.otherPolicyForm.value.index, 1, this.commonUtilty.deepCopy(otherPolicyDO))
            } else {
                this.otherPolicyList.push(this.commonUtilty.deepCopy(otherPolicyDO));
            }

            this.EmitComponentOutput(this.otherPolicyList)
            this.otherPolicyForm.reset();
        }
    }

    editOtherPolicyDetails(object, index) {
        let isEdit = true;
        this.initializeOtherPolicyForm(object, isEdit, index);
    }

    initializeOtherPolicyForm(data?, isEdit?, index?) {
        let payload = data || {}
        console.log("payload in other policy component", JSON.stringify(payload));
        this.otherPolicyForm = this.fb.group({
            id: this.validationUtilService.setValidationsForFormControl('id', this.OTHERPOLICYFORMNAME, payload['id']),
            guid: this.validationUtilService.setValidationsForFormControl('guid', this.OTHERPOLICYFORMNAME, payload['guid']),
            provider: this.validationUtilService.setValidationsForFormControl('provider', this.OTHERPOLICYFORMNAME, payload['provider']),
            // productName: "",
            policyNumber: this.validationUtilService.setValidationsForFormControl('policyNumber', this.OTHERPOLICYFORMNAME, payload['policyNum']),
            policyExpiryDt: this.validationUtilService.setValidationsForFormControl('policyExpiryDt', this.OTHERPOLICYFORMNAME, payload['expiryDt']),
            sumInsured: this.validationUtilService.setValidationsForFormControl('sumInsured', this.OTHERPOLICYFORMNAME, payload['sumInsured']),
            premium: this.validationUtilService.setValidationsForFormControl('premium', this.OTHERPOLICYFORMNAME, payload['premium']),
            term: this.validationUtilService.setValidationsForFormControl('term', this.OTHERPOLICYFORMNAME, payload['term']),
            policyStatus: this.validationUtilService.setValidationsForFormControl('policyStatus', this.OTHERPOLICYFORMNAME, payload['statusCd']),
            isEdit: this.validationUtilService.setValidationsForFormControl('isEdit', this.OTHERPOLICYFORMNAME, isEdit),
            index: this.validationUtilService.setValidationsForFormControl('index', this.OTHERPOLICYFORMNAME, index),
        });
    }

    removeOtherPolicyDetails(index) {
        this.otherPolicyForm.reset();
        this.otherPolicyList.splice(index, 1);
    }

    clearForm() {
        this.otherPolicyForm.reset();
    }
}
